import { Box, Button, CircularProgress, Typography } from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import CustomSwipableDrawer from "../customSwipableDrawer/CustomSwipableDrawer";
import readingDifficultyConfirmationImg from "../../assets/reading-difficulty-confirmation-img.svg";
import "./styles.css";

const ReadingDifficultyConfirmationDrawer = ({
  openDrawer,
  onClickPrimaryButton,
  onClickSecondaryButton,
  uploadDataLoading,
}) => {
  const { t, activeLanguage } = useTranslationSetup();

  return (
    <CustomSwipableDrawer
      open={openDrawer}
      preventDefault={true}
      anchor="bottom"
      className="reading-difficulty-confirmation"
    >
      <Box className="reading-difficulty-confirmation-img-container">
        <img
          src={readingDifficultyConfirmationImg}
          alt="reading-difficulty-confirmation-img"
        />
      </Box>
      <Typography
        fontSize="16px"
        fontFamily="poppins-medium"
        textAlign="center"
        color="#353535"
        padding="0 22px 0"
      >
        {t("reading-difficulty-confirmation-header")}
      </Typography>
      <Typography
        fontSize="14px"
        fontFamily="poppins-regular"
        textAlign="center"
        color="#6E6E6E"
        padding="2vh 21px 4vh"
      >
        {t("reading-difficulty-confirmation-description")}
      </Typography>
      <Box className="reading-difficulty-confirmation-button-container">
        <Button
          className="custom-ff-regular reading-difficulty-confirmation-retake-button theme-color btn-primary"
          variant="contained"
          lang={activeLanguage}
          disableElevation
          onClick={onClickSecondaryButton}
          disabled={uploadDataLoading}
        >
          {t("yes_read_easy_paragraph")}
        </Button>
      </Box>
      <Box className="reading-difficulty-confirmation-button-container">
        <Button
          className="custom-ff-regular reading-difficulty-confirmation-save-button theme-color"
          variant="outlined"
          lang={activeLanguage}
          disableElevation
          onClick={onClickPrimaryButton}
          disabled={uploadDataLoading}
        >
          {uploadDataLoading ? (
            <CircularProgress className="reading-difficulty-confirmation-button-loader" />
          ) : (
            t("no_choose_next_student")
          )}
        </Button>
      </Box>
    </CustomSwipableDrawer>
  );
};

export default ReadingDifficultyConfirmationDrawer;
